/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InsuranceDraft } from './InsuranceDraft';
import {
    InsuranceDraftFromJSON,
    InsuranceDraftFromJSONTyped,
    InsuranceDraftToJSON,
    InsuranceDraftToJSONTyped,
} from './InsuranceDraft';
import type { DeliveryLocationInfoDraft } from './DeliveryLocationInfoDraft';
import {
    DeliveryLocationInfoDraftFromJSON,
    DeliveryLocationInfoDraftFromJSONTyped,
    DeliveryLocationInfoDraftToJSON,
    DeliveryLocationInfoDraftToJSONTyped,
} from './DeliveryLocationInfoDraft';
import type { EmergencyContactDetailsDraft } from './EmergencyContactDetailsDraft';
import {
    EmergencyContactDetailsDraftFromJSON,
    EmergencyContactDetailsDraftFromJSONTyped,
    EmergencyContactDetailsDraftToJSON,
    EmergencyContactDetailsDraftToJSONTyped,
} from './EmergencyContactDetailsDraft';
import type { LocationInfoDraft } from './LocationInfoDraft';
import {
    LocationInfoDraftFromJSON,
    LocationInfoDraftFromJSONTyped,
    LocationInfoDraftToJSON,
    LocationInfoDraftToJSONTyped,
} from './LocationInfoDraft';
import type { BrokerDraft } from './BrokerDraft';
import {
    BrokerDraftFromJSON,
    BrokerDraftFromJSONTyped,
    BrokerDraftToJSON,
    BrokerDraftToJSONTyped,
} from './BrokerDraft';
import type { LineItemInfoDraft } from './LineItemInfoDraft';
import {
    LineItemInfoDraftFromJSON,
    LineItemInfoDraftFromJSONTyped,
    LineItemInfoDraftToJSON,
    LineItemInfoDraftToJSONTyped,
} from './LineItemInfoDraft';

/**
 * Represents a draft shipment request.
 * 
 * @export
 * @interface ShipmentDraft
 */
export interface ShipmentDraft {
    /**
     * 
     * @type {string}
     * @memberof ShipmentDraft
     */
    readonly shipmentDraftId?: string;
    /**
     * 
     * @type {Date}
     * @memberof ShipmentDraft
     */
    readonly createdAt?: Date;
    /**
     * 
     * @type {LocationInfoDraft}
     * @memberof ShipmentDraft
     */
    pickup?: LocationInfoDraft;
    /**
     * 
     * @type {DeliveryLocationInfoDraft}
     * @memberof ShipmentDraft
     */
    delivery?: DeliveryLocationInfoDraft;
    /**
     * Line items in the shipment.
     * @type {Array<LineItemInfoDraft>}
     * @memberof ShipmentDraft
     */
    lineItems?: Array<LineItemInfoDraft>;
    /**
     * 
     * @type {BrokerDraft}
     * @memberof ShipmentDraft
     */
    broker?: BrokerDraft;
    /**
     * 
     * @type {EmergencyContactDetailsDraft}
     * @memberof ShipmentDraft
     */
    emergencyContact?: EmergencyContactDetailsDraft;
    /**
     * 
     * @type {InsuranceDraft}
     * @memberof ShipmentDraft
     */
    insurance?: InsuranceDraft;
    /**
     * ID of the branch from your addressbook. Only required if you want to code shipments to particular branch locations. Please contact your account manager to set this up if required
     * @type {string}
     * @memberof ShipmentDraft
     */
    branchId?: string;
    /**
     * Custom metadata for your integration use. Store any string data (JSON, XML, etc.) up to 16KB. This field is returned in API responses and webhook payloads but is not processed or validated by FreightSimple.
     * @type {string}
     * @memberof ShipmentDraft
     */
    metadata?: string | null;
    /**
     * Extra email addresses that receive a notification when this shipment is booked, in addition to the delivery contact.
     * @type {Array<string>}
     * @memberof ShipmentDraft
     */
    additionalNotificationEmails?: Array<string> | null;
}

/**
 * Check if a given object implements the ShipmentDraft interface.
 */
export function instanceOfShipmentDraft(value: object): value is ShipmentDraft {
    return true;
}

export function ShipmentDraftFromJSON(json: any): ShipmentDraft {
    return ShipmentDraftFromJSONTyped(json, false);
}

export function ShipmentDraftFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShipmentDraft {
    if (json == null) {
        return json;
    }
    return {
        
        'shipmentDraftId': json['shipmentDraftId'] == null ? undefined : json['shipmentDraftId'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'pickup': json['pickup'] == null ? undefined : LocationInfoDraftFromJSON(json['pickup']),
        'delivery': json['delivery'] == null ? undefined : DeliveryLocationInfoDraftFromJSON(json['delivery']),
        'lineItems': json['lineItems'] == null ? undefined : ((json['lineItems'] as Array<any>).map(LineItemInfoDraftFromJSON)),
        'broker': json['broker'] == null ? undefined : BrokerDraftFromJSON(json['broker']),
        'emergencyContact': json['emergencyContact'] == null ? undefined : EmergencyContactDetailsDraftFromJSON(json['emergencyContact']),
        'insurance': json['insurance'] == null ? undefined : InsuranceDraftFromJSON(json['insurance']),
        'branchId': json['branchId'] == null ? undefined : json['branchId'],
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
        'additionalNotificationEmails': json['additionalNotificationEmails'] == null ? undefined : json['additionalNotificationEmails'],
    };
}

  export function ShipmentDraftToJSON(json: any): ShipmentDraft {
      return ShipmentDraftToJSONTyped(json, false);
  }

  export function ShipmentDraftToJSONTyped(value?: Omit<ShipmentDraft, 'shipmentDraftId'|'createdAt'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pickup': LocationInfoDraftToJSON(value['pickup']),
        'delivery': DeliveryLocationInfoDraftToJSON(value['delivery']),
        'lineItems': value['lineItems'] == null ? undefined : ((value['lineItems'] as Array<any>).map(LineItemInfoDraftToJSON)),
        'broker': BrokerDraftToJSON(value['broker']),
        'emergencyContact': EmergencyContactDetailsDraftToJSON(value['emergencyContact']),
        'insurance': InsuranceDraftToJSON(value['insurance']),
        'branchId': value['branchId'],
        'metadata': value['metadata'],
        'additionalNotificationEmails': value['additionalNotificationEmails'],
    };
}

